__turbopack_context__.v({
  "body": "table-module__5H81KW__body",
  "cell": "table-module__5H81KW__cell",
  "empty": "table-module__5H81KW__empty",
  "emptyRow": "table-module__5H81KW__emptyRow",
  "head": "table-module__5H81KW__head",
  "headCell": "table-module__5H81KW__headCell",
  "table": "table-module__5H81KW__table",
  "wrapper": "table-module__5H81KW__wrapper",
});
